import { WarehouseTab } from 'app/common/types/warehouse/tabs'
import { Underconstruction } from '../Underconstruction'

export const masks = []
export const section = 'settings'

export const WarehouseSettingsPage = (props: {
  baseUrl: string
  siblings: Array<{ section: string; baseUrl: string; otherUrls: Array<string> }>
}) => {
  return <Underconstruction tab={WarehouseTab.Movements} />
}
